
import 'babel-polyfill';

import 'js/filter';
import {
    Select,
    Option,
    OptionGroup,
    Dialog,
    Autocomplete,
    MessageBox,
    Message,
    Loading,
    Pagination,
    Input,
    Checkbox,
    Radio,
    DatePicker,
    Form,
    FormItem,
    Upload,
    Button,
    Cascader,
    Steps,
    Step
} from 'element-ui';
import 'scss/common.scss';
import 'scss/element-variables.scss';

import top from 'components/top';
// import side from 'components/side';
import bottom from 'components/bottom';

import util from './util';
import config from '../../config';

Vue.use(util);
Vue.use(Select);
Vue.use(Option);
Vue.use(OptionGroup);
Vue.use(Dialog);
Vue.use(Autocomplete);
Vue.use(Pagination);
Vue.use(Input);
Vue.use(Checkbox);
Vue.use(Radio);
Vue.use(DatePicker);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Loading.directive);
Vue.use(Upload);
Vue.use(Button);
Vue.use(Cascader);
Vue.use(Steps);
Vue.use(Step);

Vue.component('Top', top);
Vue.component('Bottom', bottom);
// Vue.component('Side', side);

Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;
Vue.prototype.checkConfirmInfo = function (){  // 在定投 购买 转换 赎回 页面时检测用户是否完成纳税人信息确认
    // var that = this
    // if (that.userData.finish_CRS === '1') {  // 0-已完成 1-未完成
    //     this.$alert('该用户未完成纳税人信息确认', '提示', {
    //         confirmButtonText: '确定',
    //         callback: function () {
    //             window.location.href = "/accountcenter/settings/confirm-info.html"
    //         }
    //     });
    // }else{

    // }
};
if (process.env.NODE_ENV === 'development') {
    // 编译环境
    window.ajaxUrl = config.dev.ajaxUrl;
    window.platformUrl = config.dev.platformUrl;
    window.backIndexUrl = config.dev.backIndexUrl;
} else {
    // PDT环境
    if (process.env.type === 'pdt') {
        window.IS_PDT = 'IS_PDT'
        window.ajaxUrl = config.pdt.ajaxUrl;
        window.platformUrl = config.pdt.platformUrl;
        window.backIndexUrl = config.pdt.backIndexUrl;
    // UAT环境
    }else {
        window.IS_UAT = 'IS_UAT'
        window.ajaxUrl = config.build.ajaxUrl;
        window.platformUrl = config.build.platformUrl;
        window.backIndexUrl = config.build.backIndexUrl;
    }
}

Vue.config.productionTip = false;

var noScroll,
    scroll,
    oDiv = document.createElement('DIV');

oDiv.style.cssText = 'position:absolute; top:-1000px; width:100px; height:100px; overflow:hidden;';
noScroll = document.body.appendChild(oDiv).clientWidth;
oDiv.style.overflowY = 'scroll';
scroll = oDiv.clientWidth;
document.body.removeChild(oDiv);

window.scrollBar = noScroll - scroll;

jQuery.support.cors = true;

window.oldToken = sessionStorage.getItem('access_token');

//全局添加埋点
$(document).ready(function (){
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.googletagmanager.com/gtag/js?id=UA-131558908-1';     //填自己的js路径
    $('body').append(script);
    window.dataLayer = window.dataLayer || [];
    function gtag (){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', 'UA-131558908-1');

})



// WEBPACK FOOTER //
// ./src/js/common.js